import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import type { PanelInformation, GetPanelInformation } from './types';

const GET_PANEL_INFORMATION = gql`
  query ($filter: PanelBaseFilter) {
    panel(filter: $filter) {
      panelNo
      title
      panelType
      panelRound
      totalRound
      fundingSource
      endDate
    }
  }
`;

export const useGetPanelInformation = (filter: any): GetPanelInformation => {
  const { data, loading, error } = useQuery(GET_PANEL_INFORMATION, {
    variables: { filter },
    fetchPolicy: 'network-only',
  });

  const {
    panelNo,
    title,
    panelType,
    panelRound,
    totalRound,
    fundingSource,
    endDate,
  } = data?.panel ?? {};

  const panelInfo: PanelInformation = {
    panelNo,
    title,
    panelType,
    panelRound,
    totalRound,
    fundingSource,
    endDate: endDate !== undefined ? endDate.slice(0, 10) : endDate,
  };

  return { panelInfo, loading, error };
};
